import { webApi } from "../../../../core/http/httpThunks";
import { EarningsEstemateApiResponse } from "../types";

export const getSecurityEarningsEstimateApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<EarningsEstemateApiResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getSecurityEarningsEstimateApi;
